import { useEffect, useRef } from "react";
import calculatePortfolio from "../utils/calculatePortfolio";

export default function usePortfolioUpdater({ triggerOnLogin = true }) {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (triggerOnLogin) {
      calculatePortfolio();
    }

    intervalRef.current = setInterval(() => {
      calculatePortfolio();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [triggerOnLogin]);

  const triggerManually = () => {
    calculatePortfolio();
  };

  return { triggerManually };
}
